let computedApi = {
  name: "计价接口",
  updateTime: "2020-05-30 10:00:00",
  methods: 'post',
  url: 'ygw.api.order.price',
  request: [{
    params: 'distributionType',
    type: "Number",
    required: true,
    length: 1,
    description: {
      text: '配送方式',
      value: ['0:邮寄', '1:到店自提', '2:送货上门']
    },
    example: '0'
  }, {
    params: 'express',
    type: "String",
    required: false,
    length: 10,
    description: {
      text: '邮寄方式快递公司选择',
      value: ['SF:顺丰', 'JD:京东', 'distributionType为0时必填']
    },
    example: 'SF'
  }, {
    params: '+recipient',
    type: "Object",
    required: false,
    length: 300,
    description: {
      text: '收货人信息',
      value: ['配送方式不为1时必填']
    },
    example: ''
  }, {
    params: '└provinceCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '收货地址省编码',
      value: []
    },
    example: 440000
  }, {
    params: '+goodsList',
    type: "Object[]",
    required: true,
    length: '',
    description: {
      text: '产品清单列表',
      value: []
    },
    example: ''
  }, {
    params: '└goodsCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '油柑编码',
      value: []
    },
    example: '04SUP000001'
  }, {
    params: '└quantity',
    type: "Number",
    required: true,
    length: '32',
    description: {
      text: '购买数量（pcs）',
      value: []
    },
    example: '100000'
  }, ],
  reseponse: [{
    params: 'goodsAmount',
    type: "Number",
    required: true,
    length: '-',
    description: {
      text: '商品价格',
      value: []
    },
    example: '24.80'
  }, {
    params: 'payAmount',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: '支付价格',
      value: []
    },
    example: '36.80'
  }, {
    params: 'expressAmount',
    type: "Number",
    required: false,
    length: '',
    description: {
      text: '快递费',
      value: []
    },
    example: '12.00'
  }, {
    params: 'totalAmount',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: '总价',
      value: []
    },
    example: '36.80'
  }],
  code: {
    sign: "ec40c739613802655e3720aaf8406531",
    appId: "9527",
    method: "ygw.api.order.price",
    params: JSON.stringify({
      distributionType: 0,
      express: "JD",
      recipient: {
        provinceCode: 440000
      },
      goodsList: [{
        goodsCode: '04SUP000001',
        quantity: 10000
      }]
    })
  }
}

export default computedApi;